export default {
    GET_COURSE_REQUEST: 'COURSE_EDIT_ATTACHMENTS_GET_COURSE_REQUEST',
    GET_COURSE_SUCCESS: 'COURSE_EDIT_ATTACHMENTS_GET_COURSE_SUCCESS',
    UPLOAD_ATTACHMENT_REQUEST: 'COURSE_EDIT_ATTACHMENTS_UPLOAD_ATTACHMENT_REQUEST',
    UPLOAD_ATTACHMENT_SUCCESS: 'COURSE_EDIT_ATTACHMENTS_UPLOAD_ATTACHMENT_SUCCESS',
    UPDATE_ATTACHMENTS_REQUEST: 'COURSE_EDIT_ATTACHMENTS_UPDATE_ATTACHMENTS_REQUEST',
    UPDATE_ATTACHMENTS_SUCCESS: 'COURSE_EDIT_ATTACHMENTS_UPDATE_ATTACHMENTS_SUCCESS',
    DISPOSE: 'COURSE_EDIT_ATTACHMENTS_DISPOSE_STORE',
};
